import { create } from 'zustand';

export type CommandMode = 'move' | 'attack-move';

interface CommandModeState {
  mode: CommandMode;
  setMode: (mode: CommandMode) => void;
}

export const useCommandModeStore = create<CommandModeState>((set) => ({
  mode: 'move',
  setMode: (mode: CommandMode) => set({ mode }),
}));
